var app = angular.module('navigation.navtop', []);

    require('./directives/navtop.directive.js');
    require('./stylesheet/header.scss');
     require('./stylesheet/header_log.scss');

module.exports = 'navigation.navtop';


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/header/index.js
 ** module id = 251
 ** module chunks = 1
 **/